import { defineMessages } from 'react-intl'

const scope = 'procurify.components.BillItemPopover'

export default defineMessages({
  receivedTitle: {
    id: `${scope}.title`,
    defaultMessage: 'Received',
  },
  unitCostVarianceTitle: {
    id: `${scope}.unitCostVarianceTitle`,
    defaultMessage: 'Unit cost variance',
  },
  receivedLabel: {
    id: `${scope}.receivedLabel`,
    defaultMessage: 'Received',
  },
  previouslyBilledLabel: {
    id: `${scope}.previouslyBilledLabel`,
    defaultMessage: 'Previously billed',
  },
  billableLabel: {
    id: `${scope}.billableLabel`,
    defaultMessage: 'Billable',
  },
  billingLabel: {
    id: `${scope}.billingLabel`,
    defaultMessage: 'Billing',
  },
  poLabel: {
    id: `${scope}.poLabel`,
    defaultMessage: 'PO',
  },
  varianceLabel: {
    id: `${scope}.varianceLabel`,
    defaultMessage: 'Variance',
  },
  statusOverbilledLabel: {
    id: `${scope}.statusOverbilledLabel`,
    defaultMessage: 'Overbilled',
  },
  statusAttentionLabel: {
    id: `${scope}.statusAttentionLabel`,
    defaultMessage: 'Attention',
  },
})
